import axios from "axios";
import { APP_PATH } from "../api/backendPath";

/**
 * useRefreshToken - Hook to refresh access token for Nurse users
 * 
 * Works for Nurse (role_id: 7) users
 * Uses the same session storage keys as doctor/pharmacy apps for consistency
 */
const useRefreshToken = () => {
  const access_token = sessionStorage.getItem("usr_1a2b3c");
  const refresh_token = sessionStorage.getItem("usr_4d5e6f");

  const refresh = async () => {
    try {
      const response = await axios.post(
        process.env.REACT_APP_API_URL + APP_PATH.refreshToken,
        { refresh_token: refresh_token },
        {
          withCredentials: true,
          headers: {
            Authorization: `Bearer ${access_token}`,
            "User-Refresh-Token": `${refresh_token}`,
            "Content-Type": "application/json",
          },
        }
      );
      return response?.data?.data;
    } catch (error) {
      console.error("Token refresh failed:", error);
      return null;
    }
  };
  return refresh;
};

export default useRefreshToken;
